module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-morse.json
// module id = 821
// module chunks = 110581640852303